<template>
  <VList class="no-background pa-4">
    <VListItemGroup>
      <VListItem
        v-for="(item, i) in items"
        :key="i"
        active-class="list-active"
        exact
        :to="item.url"
      >
        <VListItemContent>
          <VListItemTitle
            class="aside-title text-uppercase"
            v-text="item.title"
          ></VListItemTitle>
        </VListItemContent>
      </VListItem>
    </VListItemGroup>
  </VList>
</template>
<script>
export default {
  name: 'StaticInfoList',
  data: () => ({
    items: [
      {
        title: 'Terms Of Service',
        url: { name: 'info-terms' }
      },
      {
        title: 'Privacy Policy',
        url: { name: 'info-privacy' }
      },
      {
        title: 'Eula',
        url: { name: 'info-eula' }
      },
      {
        title: 'Refund Policy',
        url: { name: 'info-refund' }
      }
    ]
  })
}
</script>
